/*
 * Copyright (c) 2024 metromorph softworks GmbH
 *
 * All rights reserved
 */

import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";
import Backend from "i18next-http-backend";

export function init() {
    i18n
        .use(Backend)
        .use(initReactI18next)
        .use(LanguageDetector)
        .init({
            fallbackLng: "de",
        })
    ;
}
